export enum INCLUDE_TERMS_TYPE {
  ALL_WORDS = 'ALL_WORDS',
  ANY_WORDS = 'ANY_WORDS',
}
